import { Loader2 } from 'lucide-react';
import { cn } from '@/utils/cn';

export function Spinner({ className, label = 'Loading' }: { className?: string; label?: string }) {
  return <Loader2 className={cn('animate-spin text-brand', className)} aria-label={label} />;
}

export function LoadingScreen({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-page">
      <Spinner className="w-10 h-10" label={label} />
    </div>
  );
}
